import type { SVGProps } from 'react';

const AiLogoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill='none'
        viewBox='0 0 41 24'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M29.6416 18.2842V18.5579C29.4788 19.961 28.4044 21.0563 27.0695 21.159L2.94322 23.0413C1.25015 23.144 -0.149892 21.638 0.0129037 19.8585L1.11991 8.63296C1.25015 7.22976 2.32459 6.13459 3.65952 6.03193L9.61782 5.58701L10.4644 14.4168C10.5946 15.82 11.669 16.9152 13.004 17.0179L29.6741 18.3184L29.6416 18.2842Z'
            fill='currentColor'
        />
        <path
            d='M37.0969 18.8659L29.6408 18.2841L30.6829 7.33243C30.8456 5.55279 29.4455 4.04693 27.7526 4.14959L9.58457 5.55279L9.35665 3.1571C9.19386 1.41167 10.5939 -0.128412 12.287 0.00848426L36.4133 1.85658C37.7482 1.95925 38.8226 3.05442 38.9528 4.45762L40.0272 15.6831C40.1901 17.4628 38.7901 18.9686 37.0969 18.8659Z'
            fill='currentColor'
        />
    </svg>
);

export default AiLogoIcon;
